import clsx from 'clsx'

import {classes} from './Divider.classes'
import {Props} from './Divider.types'

export function Divider({className}: Props): React.ReactElement {
  return <hr className={clsx(classes.root, className)} />
}
